
import React from 'react';
import { StoreState } from '../../store/createStore';
import { useSelector, useDispatch } from 'react-redux';

import {
    ContainerServiceInfo,
    ContentInfo,
    ContentButton
} from './styles';
import { IoMdClose } from 'react-icons/io';
import { openShowModal } from '../../store/modules/parameter/actions';
import Button from '../Button';

const ServiceInfoModal: React.FC = () => {
    const dispatch = useDispatch();
    const { serviceInfo } = useSelector(
        (state: StoreState) => state.parameter,
    );

    const handledCloseModal = () => {
        dispatch(openShowModal(false));
    }

    if (serviceInfo) {
        return (
            <ContainerServiceInfo>
                <button onClick={handledCloseModal}><IoMdClose size={32} color="#ccc" /></button>
                <h1>{serviceInfo.service_name}</h1>
                <ContentInfo>
                    <div>{serviceInfo.service_report_header}</div>
                    <div>{serviceInfo.service_report_detail}</div>
                    <div>{serviceInfo.service_report_footer}</div>
                </ContentInfo>
                <ContentButton onClick={handledCloseModal}>
                    <Button
                        button={{ type: 'button' }}
                        atributes={{
                            buttonType: 'primary',
                            textColor: '#fff',
                            borderColor: '#dddddd',
                            textSize: '28px'
                        }}
                    >
                        VOLTAR
                    </Button>
                </ContentButton>
            </ContainerServiceInfo>
        );
    }

    return (
        <>
            Sem informações!
        </>
    )
};

export default ServiceInfoModal;